import React, { useState, useEffect } from "react";

import { useUser } from "~/Context/userContext";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import axios from "@dreamchimney/react-axios";
import styled from "styled-components";

import { getSearchResults } from "~/api/getSearch";

import { validate } from "./SearchValidationRules";
import useSearchForm from "./useSearchForm";

export const Wrapper = styled.section`
  margin: 10px 0 0 0;
`;

const Search = ({ userTo, userFrom: user, onComplete, onSubmit, onFailure }) => {
  const { state: userState } = useUser();
  const [loading, setLoading] = useState(true);

  const initialFormValues = { terms: "" };

  useEffect(() => {
    setLoading(!userState.loaded);
  }, [userState.loaded]);

  const postSearch = async () => {
    setLoading(true);
    onSubmit(true);

    try {
      // @TODO
      const searchResults = await getSearchResults(axios, inputs.terms);
      setLoading(false);
      onComplete(searchResults.data);
    } catch (err) {
      setLoading(false);
      onFailure();
    }
  };

  // const validate = true; //!loading && userState.loggedin ? validateAuth : validateNonAuth;

  const { inputs, handleInputChange, handleSubmit, errors } = useSearchForm(initialFormValues, postSearch, validate);

  return (
    <Wrapper className="">
      <Form className="totd-form totd-form-horizontal" noValidate onSubmit={(e) => handleSubmit(e)}>
        <Row>
          <Col xs={12} md={{ span: 6, offset: 2 }} className="form-left">
            {/* <p>Left Side</p> */}
            <Form.Group as={Row} className={errors.terms ? "error" : ""}>
              <Col xs={12}>
                <div>
                  <Form.Control
                    name="terms"
                    onChange={handleInputChange}
                    value={inputs.terms || ""}
                    type="text"
                    autoComplete="off"
                    required
                  />
                  {errors.terms && <span className="help error">{errors.terms}</span>}
                </div>
              </Col>
            </Form.Group>
          </Col>
          <Col xs={12} md={6} md={{ span: 2, offset: 0 }} style={{ textAlign: "left" }} className="form-right">
            {/* Right Side */}

            <Col xs={12} className="text-center">
              <Button disabled={loading} variant="success" type="submit">
                Search
              </Button>
            </Col>
          </Col>
        </Row>
      </Form>
    </Wrapper>
  );
};

export default Search;
